import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { SvcAnalysisScreen } from "./SvcAnalysisScreen";
import { SvcSessionListScreen } from "./SvcSessionsList/SvcSessionListScreen";
import { SvcAnalysisSetListScreen } from "./AnalysisSetsList/SvcAnalysisSetListScreen";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../Core/SecurityContext";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { PrivateRoute } from "../../Core/PrivateRoute";

export const SvcRoot = () => {
    return (
        <Routes>
            <Route index element={
               <PrivateRoute permissions={[PermissionEnum.AccessSingleSvcSession, PermissionEnum.AccessAllSvcSessions, PermissionEnum.OverreadSvcSession]}>
                <SvcSessionListScreen />
                </PrivateRoute>
                }
            />
            <Route path="Analysis" element={
               <PrivateRoute permissions={[PermissionEnum.OverreadSvcSession]}>
                <SvcAnalysisSetListScreen />
                </PrivateRoute>
            }
            />
            <Route path="Analysis/:analysisSetId/:viewState" element={
                <PrivateRoute permissions={[PermissionEnum.AccessSingleSvcSession, PermissionEnum.OverreadSvcSession]}>
                <SvcAnalysisScreen />
                </PrivateRoute>
            }
            />
        </Routes>
    );
}
